'use strict';

angular.module('app.admin', ['ui.router', 'angular-img-cropper', 'sotos.crop-image'])

.config(['$stateProvider', '$urlRouterProvider', function($stateProvider) {
        $stateProvider.state('home.adminBilling', {
                requireLogin: true,
                url: 'admin/billing',
                templateUrl: 'app/admin/partials/billing.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator'],
                    navMarker: ['admin', 'billing']
                },
                controller: 'AdminBillingCtrl'
            })
            .state('home.adminNewInfluencers', {
                requireLogin: true,
                url: 'admin/newInfluencers',
                templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/newInfluencers.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'Achoo Analyst'],
                    navMarker: ['admin', 'newinfluencers']
                },
                controller: 'AdminNewInfluencersCtrl'
            })
            .state('home.adminInfluencersPending', {
                requireLogin: true,
                url: 'admin/influencersPending',
                templateUrl: 'app/admin/influencerManagement/influencer-management-influencers-pending/influencers-pending.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'Achoo Analyst'],
                    navMarker: ['admin', 'influencersPending']
                },
                controller: 'AdminInfluencersPendingCtrl'
            })
            .state('home.adminInfluencers', {
                requireLogin: true,
                url: 'admin/influencers',
                templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/influencers.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'Achoo Analyst'],
                    navMarker: ['admin', 'influencers']
                },
                controller: 'AdminInfluencersCtrl'
            })
            .state('home.adminContent', {
                requireLogin: true,
                url: 'admin/content',
                templateUrl: 'app/admin/partials/content.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator'],
                    navMarker: ['admin', 'content']
                }
                // controller: 'AdminContentCtrl'
            })

}]).controller('AdminBillingCtrl', function ($scope) {
    var definitions = angular.copy($rootScope.definitions);
    $scope.countryListData = definitions.country;

    $scope.data = {
        mentions: 10,
        projects: 1,
        area: 1,
        customers: 100000,
        packageName: 'Enterprise',
        invoiceEmailList: [{id: 2, email: 'miralem@google.com'}],
        invoices: [
            {invoice: 'INV 007487', invoice_number: '457/1', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 1599, paid: true},
            {invoice: 'INV 007488', invoice_number: '457/2', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 1599, paid: true},
            {invoice: 'INV 007489', invoice_number: '457/3', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 2846, paid: false},
            {invoice: 'INV 007490', invoice_number: '457/4', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 1599, paid: true}
        ]
    }
})

.controller('ChannelSetting', function ($scope, $rootScope, $modalInstance, $modal, $http, data) { 
    $scope.data = data;

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

     $scope.save = function () {
         var updateChannelSettingUrl = $rootScope.apiUrl + 'admin/updateChannelSettings';

        var updateChannelSettingData = $scope.data;

        var req ={
            url: updateChannelSettingUrl,
            method: 'POST',
            data: JSON.stringify(updateChannelSettingData)
        }

        $http(req).success(function(responseUpdateChannelSetting){
            $modalInstance.dismiss('cancel');
        })
            .error(function(responseUpdateChannelSetting){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responseUpdateChannelSetting.message;
            });
    };
})

.controller('NewChannelCtrl', function ($scope, $modalInstance, $modal, $rootScope, $http, $location, $animate) {
    var definitions = angular.copy($rootScope.definitions);
    $scope.channelType = definitions.channelTypes;
    $scope.platforms = definitions.platforms;

    $scope.preloadData = function(){
        $scope.renderChannelType();
        $scope.renderPlatform();
        if($scope.index != null && $scope.index !== undefined){
            $scope.handle = $scope.index.handle;
            $scope.AddOrEdit = "Edit";
        }else{
            $scope.AddOrEdit = "Add";
        }
    }

    $scope.youtubeTypes = [{
        name: "User",
        ticked: true
    },{
        name: "Channel"
    }];

    $scope.youtubeTypes.forEach(function(val){
        if($scope.index != null && $scope.index !== undefined){
            if(val.name == $scope.index.youtubeType){
                val.ticked = true;
                $scope.selectedYoutubeType = val;
            } else {
                val.ticked = false;
            }
        }
    });

    $scope.renderChannelType = function(){
        $scope.channelType.forEach(function(val){
            if($scope.index != null && $scope.index !== undefined){
                if(val.id == $scope.index.type){
                    val.ticked = true;
                    $scope.selectedFeed = val;
                }
            }else if(val.name == "Unauthorized"){
                val.ticked = true;
            }
        });
    }

    $scope.renderPlatform = function(){
        $scope.platforms.forEach(function(val){
            if($scope.index != null && $scope.index !== undefined){
                if(val.id == $scope.index.platform_id){
                    val.ticked = true;
                    $scope.selectedPlatform = val;
                }
            }
        });
    }

    $scope.preloadData();
  
    $scope.openChannelSetting = function() {

        var getChannelSettingUrl = $rootScope.apiUrl + 'admin/getChannelSettings';

        var newChannelSettingData = {
            relative_path : $scope.index.handle
        };

        var req ={
            url: getChannelSettingUrl,
            method: 'POST',
            data: JSON.stringify(newChannelSettingData)
        }

        // Ticket IM-73
        $http(req).success(function(responseChannelSetting){
            $modal.open({       
                templateUrl: 'app/admin/partials/ChannelSettingModal.html?app_v=deployDate',
                controller: 'ChannelSetting',
                resolve: {
                    data: function () {
                        return responseChannelSetting.data;
                    }
                }
            });
        })
            .error(function(responseChannelSetting){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responseChannelSetting.message;
            });
    }

    $scope.addToInfluencer = function() {
        
        $scope.selectedPlatform = "";
        $scope.platforms.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedPlatform = val.id;
        });

        $scope.selectedFeed = "";
        $scope.channelType.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedFeed = val.id;
        });

        $scope.selectedYoutubeType = "";
        $scope.youtubeTypes.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedYoutubeType = val.name;
        });

        $scope.channels = {
            id: $scope.index == null ? null : $scope.index.id,
            platform_id: $scope.selectedPlatform,
            handle: $scope.handle,
            type: $scope.selectedFeed,
            youtubeType: $scope.selectedYoutubeType
        }
        $scope.precheckAddChannel($scope.channels);
    }

    $scope.precheckAddChannel = function(data){
        var precheckChannelUrl = $rootScope.apiUrl + 'channel/precheckChannel';

        var req ={
            url: precheckChannelUrl,
            method: 'POST',
            data: JSON.stringify(data)
        }

        $http(req).success(function(responsePrecheckChannel){
            $modalInstance.close({
                newChannel: $scope.channels
            });
        })
            .error(function(responsePrecheckChannel){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responsePrecheckChannel.message;
            });

    }

})
